import { createI18n } from 'vue-i18n'

// Import translation files
import en from './locales/en.json'
import es from './locales/es.json'

const messages = {
  en,
  es
}

// Function to detect user's country and set appropriate language
const getDefaultLanguage = async () => {
  // First check if language is already saved in localStorage
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage) {
    return savedLanguage
  }

  // Create a timeout promise
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => reject(new Error('Geolocation timeout')), 5000) // 5 second timeout
  })

  try {
    // Try primary geolocation API with timeout
    const response = await Promise.race([
      fetch('https://ipapi.co/json/'),
      timeoutPromise
    ])
    const data = await response.json()
    
    // If user is from Mexico, set Spanish as default, otherwise English
    if (data.country_code === 'MX') {
      return 'es'
    } else {
      return 'en'
    }
  } catch (error) {
    console.warn('Primary geolocation API failed, trying backup method:', error)
    
    // Try backup geolocation method with timeout
    try {
      const response = await Promise.race([
        fetch('https://api.country.is/'),
        timeoutPromise
      ])
      const data = await response.json()
      
      if (data.country === 'MX') {
        return 'es'
      } else {
        return 'en'
      }
    } catch (backupError) {
      console.warn('Backup geolocation API also failed, checking browser language:', backupError)
      
      // Fallback to browser language detection
      const browserLang = navigator.language || navigator.languages[0]
      if (browserLang && browserLang.toLowerCase().startsWith('es')) {
        return 'es'
      } else {
        return 'en'
      }
    }
  }
}

// Get default language (will be async)
let defaultLanguage = 'en' // fallback

// Initialize with fallback, then update when geolocation is available
const i18n = createI18n({
  locale: defaultLanguage,
  fallbackLocale: 'en',
  messages,
  legacy: false
})

// Set the language based on geolocation
getDefaultLanguage().then(language => {
  i18n.global.locale.value = language
  // Save the detected/set language
  localStorage.setItem('language', language)
})

export default i18n
